import React from "react";
import { Link } from "react-router-dom";
import { UserPlus, Search, Zap, Building2, Users, CheckCircle2 } from "lucide-react";
import { Layout } from "@/components/Layout";
import { useLang } from "@/context/LanguageContext";

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h1 className="font-display text-4xl font-extrabold text-navy text-center">{t("how_title")}</h1>
        <p className="mt-3 text-center text-slate-600">Simple. Free. Global. Human. Fast. Trustworthy.</p>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          <div className="gjt-card p-7 border-t-4 border-t-brand-blue">
            <div className="flex items-center gap-2 text-brand-blue font-display text-lg font-bold"><Users className="h-5 w-5" /> For Candidates</div>
            <p className="mt-1 text-sm font-semibold text-emerald-600">Free for life — no fees, ever.</p>
            <ol className="mt-5 space-y-3 text-sm text-slate-700">
              {["Create a free profile in minutes", "Declare your availability", "Get discovered by employers", "One-click apply to unlimited jobs", "Receive invitations & improve your HomeRank"].map((s, i) => (
                <li key={i} className="flex gap-3"><span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand-bluelight text-xs font-bold text-brand-blue">{i + 1}</span>{s}</li>
              ))}
            </ol>
            <Link to="/signup" className="mt-6 inline-flex gjt-btn-orange rounded-xl px-6 py-3 text-sm font-bold">Create free profile</Link>
          </div>

          <div className="gjt-card p-7 border-t-4 border-t-brand-orange">
            <div className="flex items-center gap-2 text-brand-orange font-display text-lg font-bold"><Building2 className="h-5 w-5" /> For Employers</div>
            <p className="mt-1 text-sm font-semibold text-navy">First 5 job posts FREE.</p>
            <ol className="mt-5 space-y-3 text-sm text-slate-700">
              {["Create a company profile", "Post your first 5 jobs free (30-day validity each)", "Search the global workforce", "Shortlist, invite & contact candidates", "Hire people who are ready to work"].map((s, i) => (
                <li key={i} className="flex gap-3"><span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-orange-50 text-xs font-bold text-brand-orange">{i + 1}</span>{s}</li>
              ))}
            </ol>
            <Link to="/signup?role=employer" className="mt-6 inline-flex rounded-xl bg-navy px-6 py-3 text-sm font-bold text-white">Post 5 jobs free</Link>
          </div>
        </div>

        <div className="mt-12 gjt-card p-7">
          <h2 className="font-display text-xl font-bold text-navy">Pricing after your free posts</h2>
          <div className="mt-4 grid gap-4 sm:grid-cols-2">
            <div className="rounded-xl bg-slate-50 p-5">
              <p className="text-sm font-semibold text-slate-500">India</p>
              <p className="mt-1 font-display text-2xl font-extrabold text-navy">₹500<span className="text-sm font-medium text-slate-500"> / job / city / week</span></p>
            </div>
            <div className="rounded-xl bg-slate-50 p-5">
              <p className="text-sm font-semibold text-slate-500">Global</p>
              <p className="mt-1 font-display text-2xl font-extrabold text-navy">$5<span className="text-sm font-medium text-slate-500"> / job / city / week</span></p>
            </div>
          </div>
          <p className="mt-4 flex items-center gap-2 text-sm text-slate-500"><CheckCircle2 className="h-4 w-4 text-emerald-500" /> Candidate sponsorship available at $1 / day / city — top 3 slots, ranked by performance.</p>
        </div>
      </div>
    </Layout>
  );
}
